import type { ApiResponse } from "@/services/api"
import download from "downloadjs"

// Keep in sync with essential.utils.export.FileTypeEnum
const FILE_EXPORT_FORMAT_MAP = {
  Csv: {
    label: "csv",
    value: "csv",
  },

  Xlsx: {
    label: "xlsx",
    value: "xlsx",
  },
  Ods: {
    label: "ods",
    value: "ods",
  },
} as const

export type FileExportFormat =
  (typeof FILE_EXPORT_FORMAT_MAP)[keyof typeof FILE_EXPORT_FORMAT_MAP]["value"]

export const fileExportFormatOptions = Object.values(
  FILE_EXPORT_FORMAT_MAP
)

const getFileNameFromResponse = (
  data: ApiResponse<Blob>
) => {
  const dispositionHeader = new Map(
    Object.entries(data.headers)
  ).get("content-disposition")
  const filename = dispositionHeader
    ?.split(/;(.+)/)[1]
    .split(/=(.+)/)[1]
  return filename
}

export const exportFileFromRespone = (
  data: ApiResponse<Blob>
) => {
  const filename = getFileNameFromResponse(data)
  download(data.body, filename)
}
